<div class="tag-bulk-container">
  <form [formGroup]="formGroup">
    <div class="p-grid p-fluid ">
      <div class="p-col-6 p-md-6 p-lg-6">
        <div class="label-block">
          <form-factory [formGroup]="formGroup" [model]="tagNotes"></form-factory>
        </div>
      </div>
    </div>
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-12 p-lg-12">
        <app-button text="CONTINUE TO VALIDATION" (onClick)="validateToShowTagGrid()"></app-button>
      </div>
    </div>
  </form>


  <div class="p-grid p-fluid" *ngIf="isShowValidateGridData">
    <div class="p-col-12 p-md-12 p-lg-12">
      <app-basic-grid [configuration]="serverGridConfiguration"
                       [data]="data">
      </app-basic-grid>
    </div>
    <div class="p-grid p-fluid"><app-button (onClick)="finalBulkUpdate()" text="FINISH BULK UPDATE" [disabled]="isFinalBulkUpdate"></app-button></div>
  </div>

</div>
